import { render, staticRenderFns } from "./SesionFinalizada.vue?vue&type=template&id=6d9121b9&"
import script from "./SesionFinalizada.vue?vue&type=script&lang=js&"
export * from "./SesionFinalizada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports